import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { ButtonSkeleton } from "./Button";

export interface MenuFields {
    title: EntryFieldTypes.Symbol;
    hero?: EntryFieldTypes.AssetLink;
    menuItems: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<ButtonSkeleton | MenuSkeleton>>;
    actions?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<ButtonSkeleton>>;
}

export type MenuSkeleton = EntrySkeletonType<MenuFields, "menu">;
export type Menu<Modifiers extends ChainModifiers = "WITHOUT_UNRESOLVABLE_LINKS", Locales extends LocaleCode = LocaleCode> = Entry<MenuSkeleton, Modifiers, Locales>;

export function isMenu<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is Menu<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'menu'
}
